import AppModal from "@/components/AppModal";
import AppTextField from "@/components/AppTextField";
import Backdrop from '@mui/material/Backdrop';
import {
  Box,
  Typography,
  Stack,
  styled,
  boxClasses,
  IconButton, TextField
} from '@mui/material'
import AppLoadingButton from "@/components/mui/LoadingButton";
import Fade from '@mui/material/Fade';
import API from "@/constant/API";
import {getCardList} from "@/redux/slices/card";
import {dispatch} from "@/redux/store";
import axiosInstance from "@/utils/axios";
import {isEmptyString} from "@/utils/utils";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {enqueueSnackbar} from "notistack";
import {deleteCard, modofyCardPin} from '@/services'
import classes from "./index.module.css";
import {useBoolean, useRequest} from "ahooks";
import styles from "@/components/BindEmailModal/BindEmailModal.module.css";
import RpIcon from "@/components/RpIcon.jsx";
import TwoFAModal from "@/components/TwoFAModal/index.tsx";
import {clearTaskRule, setTaskRuleParams} from "@/redux/slices/user.js";
import {VerifyAction} from "@/constant/VerifyConstant.js";

export default function CardCancelDialog({
                                           open,
                                           card,
                                           onClose,
                                         }) {
  const {t} = useTranslation();

  const [twoFAModalShow , twoFAModalShowOperate] = useBoolean(false);

  const deleteCardReq = useRequest(async () => {
    const res = await deleteCard(card.cardId)
    return res
  }, {
    manual: true,
  });

  const onConfirm = () => {
    clearTaskRule()
    setTaskRuleParams(({
      action: VerifyAction.DELETE_CARD,
    }))
    twoFAModalShowOperate.setTrue()
  }


  const onDeleteCard = async () => {
    twoFAModalShowOperate.setFalse()
    deleteCardReq.runAsync().then(() => {
      enqueueSnackbar(t('delete_successful'), {variant: 'success'})
    })
  }

  if (!card) return null;

  return (
    <>
      <AppModal open={open} onClose={onClose}
                closeAfterTransition
                slots={{backdrop: Backdrop}}
                slotProps={{
                  backdrop: {
                    timeout: 500,
                  },
                }}
      >
        <Stack direction="column" spacing={2} className={classes.modalContent}
        >
          <Stack className={classes.title} direction="row" justifyContent="space-between">
            <RpIcon
              clickable
              onClick={() => {
                onClose && onClose()
              }}
              icon="close" size={20}/>
            <Typography>Card cancellation </Typography>
          </Stack>
          < img src="/images/card/cancel.svg"/>
          {card.available > 0 &&
            <Typography>There are still assets in your account, please return them to your wallet first.</Typography>}
          {card.available <= 0 && <Typography>After cancelling the card, it will not be deactivated and this action is
            irreversible.</Typography>}
          <AppLoadingButton loading={deleteCardReq.loading} variant="contained"
                         onClick={onConfirm} fullWidth>
            {card.available > 0 ? 'Return' : 'Delete card'}
          </AppLoadingButton>
        </Stack>
      </AppModal>
      <TwoFAModal successCallback={() => { onDeleteCard() }} open={twoFAModalShow} onClose={twoFAModalShowOperate.setFalse} />

    </>
  );
}
